/**
 * Shared UTMB Index constants.
 */

/**
 * Minimum value for a UTMB Index to be considered a real index. At or below this
 * threshold the score is only a "finisher" mark, not a ranked index: the UI shows
 * "Finisher" / "UTMB Index valide" instead of the raw number.
 */
export const VALID_INDEX_THRESHOLD = 10;
